<template>
  <div class="section col_w_3">
    <div class="section_wrap">
      <h6 class="--blue70 mb20">
        {{ $t('my.payment.detailsOfUsage.title') }}
      </h6>
      <NavListTable
          :header="header"
          :list="computedList"
          :pageInfo="pageInfo"
          :activeSyncProps="activeSync"
          @resetPageInfoAndList="resetPageInfoAndList"
          @getDetailsOfUsageListFromServer="getDetailsOfUsageListFromServer"
          ref="navListTable"
      />
      <InvoiceCheckModal/>
      <NoticeSection/>
    </div>
  </div>
</template>
<script>
import _API from '@/api';
import NavListTable from '@/components/Table/navListTable';
import NoticeSection from './noticeSection';
import InvoiceCheckModal from "@/components/modal/payments/invoiceCheckModal";

export default {
  name: 'DetailsOfUsage',
  props: {
    totalPurchaseCountProps: Number
  },
  data() {
    return {
      activeSync: false,
      pageInfo: {
        page: 0, // 페이지의 인덱스
        size: 10, // 고정된 값, 보여줄 최대 row
        totalRow: 0, // 전체 게시글 row 의 갯수
      },
      header: [
        {
          index: 0,
          title: 'my.payment.detailsOfUsage.plan'
        },
        {
          index: 1,
          title: 'my.payment.detailsOfUsage.pay'
        },
        {
          index: 2,
          title: 'my.payment.detailsOfUsage.billing_method'
        },
        {
          index: 3,
          title: 'my.payment.detailsOfUsage.period',
          width: '25%'
        },
        {
          index: 4,
          title: 'my.payment.detailsOfUsage.invoice'
        }
      ],
      detailList: []
    }
  },
  components: {
    NavListTable,
    NoticeSection,
    InvoiceCheckModal
  },
  watch: {
    totalPurchaseCountProps() {
      this.pageInfo.totalRow = this.totalPurchaseCountProps;
      this.$refs.navListTable.makePageNavigation();
    }
  },
  computed: {
    computedList() {
      const computedList = [];

      this.detailList.forEach((item) => {
        const tempArr = [];
        tempArr.push({
          keyType: 'DefaultInfoInput',
          values: item.baseProductInfo.defaultProductTitle
        });
        tempArr.push({
          keyType: 'DefaultInfoInput',
          values: `${item.amount} ${item.baseProductInfo.productAmountUnit}`
        });
        tempArr.push({
          keyType: 'DefaultInfoInput',
          values: `${item.cardType}(${item.maskedCardNumber})`
        });
        tempArr.push({
          keyType: 'DefaultInfoInput',
          values: `${this.moment(item.billingDate).locale(this.$t('country')).format('ll')}
          - ${this.moment(item.expirationDate).subtract(1, 'day').locale(this.$t('country')).format('ll')}
          `
        });
        tempArr.push({
          keyType: 'ButtonBox',
          values: 'Invoice check',
          class: 'small-line-button-blue70',
          event: () => {
            this.$modal.show('invoice-check-modal', item)
          },
        });
        computedList.push(tempArr);
      })

      return computedList
    }
  },
  created() {
    this.getDetailsOfUsageListFromServer();
  },
  methods: {
    getDetailsOfUsageListFromServer() {
      const inputData = {
        page: this.pageInfo.page,
        size: this.pageInfo.size
      }
      this.activeSync = true;
      _API.PAYMENT.getMyPurchaseHistory(inputData)
          .then(({data}) => {
            if (data.isSuccess) {
              this.detailList.clear();
              this.detailList = data.purchaseHistoryList;
            }
            this.activeSync = false;
          });
    },
    resetPageInfoAndList(pageNum) {
      this.pageInfo.page = (pageNum - 1);
    }
  }
}
</script>